
import { createSlice } from "@reduxjs/toolkit";

const addressSlice = createSlice({
  name: "address",
  initialState: {
    data: [],
    formData: null,
  },
  reducers: {
    setAddressData: (state, action) => {
      const newAddress = action.payload.apiResponse;
      const existingIndex = state.data.findIndex(
        (item) => item.id === newAddress.id
      );

      if (existingIndex !== -1) {
        // Update the existing address
        state.data[existingIndex] = newAddress;
      } else {
        // Add new address
        state.data.push(newAddress);
      }

      state.formData = action.payload.formData;
    },

    deleteAddressById: (state, action) => {
      state.data = state.data.filter((item) => item.id !== action.payload);
    },
  },
});

export const { setAddressData, deleteAddressById } = addressSlice.actions;

export default addressSlice.reducer;
